import { TechnicalError } from '@orus.eu/error'

export function assert(condition: unknown, message: string): asserts condition {
  if (condition) return

  throw new TechnicalError(message)
}
